import React, { useCallback, useEffect, useMemo, useState } from "react";

import { Link, useParams, useHistory } from "react-router-dom";
import { ColumnsType } from "antd/lib/table";
import { useTranslation } from "react-i18next";
import { Button, Col, Row, Space, Tag, Tooltip, Typography, Badge } from "antd";
import * as Yup from "yup";
import {
  ArrowLeftOutlined,
  BarcodeOutlined,
  BranchesOutlined,
  CalendarOutlined,
  DeploymentUnitOutlined,
  FileProtectOutlined,
  FileSearchOutlined,
  FileSyncOutlined,
  ForkOutlined,
  IdcardOutlined,
  MailOutlined,
  PhoneOutlined,
  PlusCircleOutlined,
  SwapOutlined,
  UserOutlined,
  CloseOutlined,
  WarningOutlined,
  EditOutlined,
  FilePptOutlined,
} from "@ant-design/icons";
import { parseISO } from "date-fns";
import moment from "moment";
import { Card } from "../../components/ui";
import ActivityStatus from "../../enums/ActivityStatus";
import ProjectStatus from "../../enums/ProjectStatus";
import AddActivityAllTime from "./AddActivityAllTime";
import { useToast } from "../../hooks/toast";
import api from "../../services/api";
import { ICustomer } from "../Customers";
import { IProject, IProjectType } from "../Projects";
import { IUser } from "../Users";
import Table from "../../components/Table";
import UserAvatar from "../../components/UserAvatar";
import { FiltersCard } from "../../components/Filters";
import {
  ActionsContainer,
  CardContainer,
  Container,
  FloatActionsContainer,
  Header,
} from "./styles";
import { useAuth } from "../../hooks/auth";
import Stat from "../../components/Stat";
import ProjectTypes from "../../enums/ProjectTypes";
import ActivityModal from "./ActivityModal";
import ProjectActions, { IProposal } from "../../components/ProjectActions";
/* import ConcludeActivityModal from "../Activities/ConcludeActivityModal"; */
import AssignActivityModal from "../Activities/AssignActivityModal";
import ActivityActionsHistoryModal from "../Activities/ActivityActionsHistoryModal";
import UserRoles from "../../enums/UserRoles";
import EditFieldModal from "../../components/ProjectActions/EditFieldModal";
import FieldValueHistoryModal from "./FieldValueHistoryModal";
import StatusDateExpected from "../FactoryActivity/StatusDateExpected";
import HistoricActivityModal from "../FactoryActivity/HistoricActivityModal";
import DeleteActivityModal from "./DeleteActivityModal";
import RemoveImpediment from "./RemoveImpediment";
import IStatusImpediment from "../../interfaces/IStatusImpediment";
import ActivityEditModal from "./AddActivityAllTime/EditModal";
/* import EstimatorActivities from "../Activities/EstimatorActivities"; */

const { Paragraph } = Typography;

interface IParams {
  projectId: string;
}

export interface IComments {
  id: string;
  comment_estimator?: string;
  comment_activity?: string;
  created_at: string;
  updated_at: string;
  status?: string;
  user: IUser;
}

export interface IRequirement {
  id: string;
  identifier: string;
  description: string;
  month: number;
  year: number;
  hours: number;
  wasted_hours: number;
  type: string;
  status: ActivityStatus;
  consultant_id: string;
  project_id: string;
  last_status_update: string;
  created_at: string;
  consultant?: IUser;
  actionsHistory: IActionHistoryItem[];
  project: IProject;
  report_fiche_service: boolean;
  number_fiche_service: string;
  number_nf: string;
  estimator?: IUser;
  estimator_id?: string;
  expected_date_begin: string;
  expected_date_end: string;
  date_begin_activity: string;
  comments?: IComments[];
  hoursFactory?: {
    configHour: { description: string; value_hour: number; id: string };
  };
}

interface IActionHistoryItem {
  id: string;
  old_status: ProjectStatus | ActivityStatus;
  new_status: ProjectStatus | ActivityStatus;
  object_type: "PROJECT" | "ACTIVITY";
  object_id: string;
  reason?: string;
  user_id: string;
  assigned_user_id?: string;
  created_at: Date;
}

export interface IDetailedProject {
  id: string;
  identifier?: string;
  short_description: string;
  full_description: string;
  contractor_name?: string;
  contractor_email?: string;
  contractor_phone_number?: string;
  status: string;
  purchase_order?: string;
  customer?: ICustomer;
  manager: IUser;
  completion_date?: Date;
  created_at: Date;
  projectType: IProjectType;
  requirements: IRequirement[];
  actionsHistory: IActionHistoryItem[];
  estimation?: number;
  baseProject: IDetailedProject;
  expected_start?: string;
  expected_end?: string;
  confirm_estimate?: boolean;
  pricing?: string;
  public_project: boolean;
  proposal_number_ethic?: string;
}

type ICommentsActivity = "comment_activity" | "comment_estimator";

const Project: React.FC = () => {
  const { projectId } = useParams<IParams>();
  const { addToast } = useToast();
  const { t } = useTranslation(["activities", "projects"]);
  const { user } = useAuth();
  const history = useHistory();

  const [comments, setComments] = useState<ICommentsActivity>();
  const [
    modalRemoveImpedimentVisible,
    setModalRemoveImpedimentVisible,
  ] = useState(false);
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [modalAddActivityVisible, setModalAddActivityVisible] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [project, setProject] = useState<IDetailedProject>();
  const [proposal, setProposal] = useState<IProposal>();
  const [activities, setActivities] = useState<IRequirement[]>([]);
  const [managers, setManagers] = useState<IUser[]>([]);
  // Activities actions
  const [selectedActivity, setSelectedActivity] = useState<IRequirement>();
  const [visibleActivityFactory, setVisibleActivityFactory] = useState(false);
  const [assignActivityModalVisible, setAssignActivityModalVisible] = useState<
    boolean
  >(false);
  const [
    activityActionsModalVisible,
    setActivityActionsModalVisible,
  ] = useState<boolean>(false);

  const [modalDeleteVisible, setModalDeleteVisible] = useState(false);
  const [modalEditVisible, setModalEditVisible] = useState(false);

  const userExistProject = useMemo(
    () => project?.requirements?.some(req => req.consultant_id === user.id),
    [project, user.id],
  );

  const isLoggedUserManager = useMemo(
    () =>
      user.role === UserRoles.Manager || user.role === UserRoles.Administrative,
    [user.role],
  );
  useEffect(() => {
    if (isLoggedUserManager) {
      api
        .get<IUser[]>("/users", {
          params: {
            role: "MANAGER",
          },
        })
        .then(response => {
          setManagers(response.data);
        })
        .catch(() => {
          addToast({
            type: "error",
            title: "Erro na busca",
            description:
              "Occoreu um erro ao buscar os gestores, tente novamente.",
          });
        });
    }
  }, [addToast, isLoggedUserManager]);

  const managerOptions = useMemo(() => {
    if (!managers) {
      return undefined;
    }

    return managers.map(manager => ({
      label: manager.name,
      value: manager.id,
    }));
  }, [managers]);

  useEffect(() => {
    setLoading(true);
    api
      .get<IDetailedProject>(`/projects/${projectId}`)
      .then(response => {
        setProject(response.data);
        setActivities(response.data.requirements);
      })
      .catch(() => {
        addToast({
          type: "error",
          title: "Erro na busca",
          description:
            "Occoreu um erro ao buscar os projetos, tente novamente.",
        });
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  useEffect(() => {
    api
      .get<IProposal>(`/proposal/generate/${projectId}`, {
        params: {
          request_status: "full",
        },
      })
      .then(response => {
        setProposal(response.data);
      });
  }, [project?.id]);

  const isAllocation = useMemo(
    () => project?.projectType.acronym === ProjectTypes.Allocation,
    [project?.projectType.acronym],
  );

  const handleOpenAssignActivityModal = useCallback(
    (activity: IRequirement) => {
      setSelectedActivity(activity);
      setAssignActivityModalVisible(true);
    },
    [],
  );

  const handleOpenEditActivityModal = useCallback((activity: IRequirement) => {
    setSelectedActivity(activity);
    setModalEditVisible(true);
  }, []);

  const handleOpenActionsHistoryModal = useCallback(
    (activity: IRequirement) => {
      setSelectedActivity(activity);
      setActivityActionsModalVisible(true);
    },
    [],
  );

  const handleOpenDeleteActivityModal = useCallback(
    (activity: IRequirement) => {
      setSelectedActivity(activity);
      setModalDeleteVisible(true);
    },
    [],
  );

  const handleOpenActivityModal = useCallback(
    (activity: IRequirement, commentsActivity: ICommentsActivity) => {
      setSelectedActivity(activity);
      setComments(commentsActivity as ICommentsActivity);
      setVisibleActivityFactory(true);
    },
    [],
  );

  const handleOpenModalRemoveImpediment = useCallback(
    (activity: IRequirement) => {
      setSelectedActivity(activity);
      setModalRemoveImpedimentVisible(true);
    },
    [],
  );

  const requirementsColumns: ColumnsType<IRequirement> = isAllocation
    ? [
        {
          title: t("hours"),
          dataIndex: "hours",
          render: (hours: number) => hours && `${hours} h`,
        },
        {
          title: t("allocation_month"),
          dataIndex: "month",
          render: (month, record: IRequirement) => {
            const date = new Date(record.year, record.month);
            return moment(date).format("MMMM [de] YYYY");
          },
        },
        {
          title: t("consultant"),
          dataIndex: "consultant",
          render: (consultant: IUser) => {
            if (consultant) {
              return (
                <UserAvatar
                  name={consultant.name}
                  url={consultant.avatar_url}
                  size={36}
                />
              );
            }
            return <></>;
          },
        },
        {
          title: t("status.label"),
          dataIndex: "status",
          render: (status: string) => {
            return (
              <Tag color={t(`status.options.${status}.color`)} key={status}>
                {t(`status.options.${status}.label`)}
              </Tag>
            );
          },
        },
        {
          title: t("actions.label"),
          dataIndex: "actions",
          fixed: "right",
          render: (_, record) => (
            <>
              {isLoggedUserManager && (
                <>
                  <Tooltip title="Apagar Atividade">
                    <Button
                      onClick={() => {
                        handleOpenDeleteActivityModal(record);
                      }}
                      type="link"
                      icon={
                        <CloseOutlined
                          style={{
                            color: "#ff0000",
                          }}
                        />
                      }
                    />
                  </Tooltip>
                </>
              )}
            </>
          ),
        },
      ]
    : [
        {
          title: t("identifier"),
          dataIndex: "identifier",
        },
        {
          title: t("description"),
          dataIndex: "description",
        },
        {
          title: "status de desenvolvimento",
          dataIndex: "expected_date_begin",
          render: (
            expected_date_begin: string,
            { expected_date_end, date_begin_activity, status }: IRequirement,
          ) => {
            return (
              <>
                <StatusDateExpected
                  beginDate={expected_date_begin}
                  endDate={expected_date_end}
                  date_begin_activity={date_begin_activity}
                  status={status}
                />
              </>
            );
          },
        },
        {
          title: t("types.label"),
          dataIndex: "type",
          render: (type: string) => {
            return (
              <Tag color={t(`types.options.${type}.color`)} key={type}>
                {t(`types.options.${type}.label`)}
              </Tag>
            );
          },
        },
        {
          title: t("status.label"),
          dataIndex: "status",
          render: (status: string) => {
            return (
              <Tag color={t(`status.options.${status}.color`)} key={status}>
                {t(`status.options.${status}.label`)}
              </Tag>
            );
          },
        },
        {
          title: t("estimation"),
          dataIndex: "hours",
          render: (estimation: number) => estimation && `${estimation} h`,
        },
        {
          title: t("wasted_hours"),
          dataIndex: "wasted_hours",
          render: (wasted: number) => wasted && `${wasted} h`,
        },
        {
          title: t("consultant"),
          dataIndex: "consultant",
          render: (consultant: IUser) => {
            if (consultant) {
              return (
                <UserAvatar
                  name={consultant.name}
                  url={consultant.avatar_url}
                  size={36}
                />
              );
            }
            return <></>;
          },
        },
        {
          title: "Estimador",
          dataIndex: "estimator",
          render: (estimator: IUser) => {
            return estimator ? (
              <UserAvatar
                name={estimator?.name || ""}
                url={estimator?.avatar_url || ""}
                size={36}
              />
            ) : (
              <></>
            );
          },
        },
        {
          title: t("actions.label"),
          dataIndex: "actions",
          fixed: "right",
          render: (_, record) => (
            <>
              {isLoggedUserManager &&
              record.status !== ActivityStatus.Executed ? (
                <>
                  <Tooltip title="Atribuir">
                    <Button
                      onClick={() => handleOpenAssignActivityModal(record)}
                      type="link"
                      icon={<SwapOutlined />}
                    />
                  </Tooltip>
                  <Tooltip title="Ver histórico">
                    <Button
                      onClick={() => handleOpenActionsHistoryModal(record)}
                      type="link"
                      icon={<FileSearchOutlined />}
                    />
                  </Tooltip>
                </>
              ) : (
                <Tooltip title="Ver histórico">
                  <Button
                    onClick={() => handleOpenActionsHistoryModal(record)}
                    type="link"
                    icon={<FileSearchOutlined />}
                  />
                </Tooltip>
              )}
              <Tooltip title="Exibir Descrição do desenvolvimento da Atividade">
                <Button
                  onClick={
                    () => handleOpenActivityModal(record, "comment_activity")
                    // ts-ignore
                  }
                  type="link"
                  disabled={
                    !record?.comments?.filter(c => c?.comment_activity)?.length
                  }
                  icon={
                    <FileProtectOutlined
                      style={{
                        color: record?.comments?.filter(c => c.comment_activity)
                          ?.length
                          ? "green"
                          : "red",
                      }}
                    />
                  }
                />
              </Tooltip>
              <Tooltip title="Exibir Descrição do estimador da Atividade">
                <Button
                  onClick={
                    () => handleOpenActivityModal(record, "comment_estimator")
                    // ts-ignore
                  }
                  type="link"
                  disabled={
                    !record?.comments?.filter(c => c?.comment_estimator)?.length
                  }
                  icon={
                    <FileSyncOutlined
                      style={{
                        color: record?.comments?.filter(
                          c => c?.comment_estimator,
                        )?.length
                          ? "green"
                          : "red",
                      }}
                    />
                  }
                />
              </Tooltip>
              {record?.comments?.length &&
              record.comments?.every(c => c?.status === "WARNING") ? (
                <Tooltip title="Atividade com impedimento">
                  <Button
                    type="link"
                    icon={<WarningOutlined />}
                    onClick={() => handleOpenModalRemoveImpediment(record)}
                  />
                </Tooltip>
              ) : (
                <></>
              )}
              {isLoggedUserManager && (
                <>
                  <Tooltip title="Editar Atividade">
                    <Button
                      onClick={() => handleOpenEditActivityModal(record)}
                      type="link"
                      icon={<EditOutlined />}
                    />
                  </Tooltip>
                  <Tooltip title="Apagar Atividade">
                    <Button
                      onClick={() => {
                        handleOpenDeleteActivityModal(record);
                      }}
                      type="link"
                      icon={
                        <CloseOutlined
                          style={{
                            color: "#ff0000",
                          }}
                        />
                      }
                    />
                  </Tooltip>
                </>
              )}
            </>
          ),
        },
      ];

  const actionsHistoryColumns: ColumnsType<IActionHistoryItem> = [
    {
      title: t("date"),
      dataIndex: "created_at",
      render: date =>
        date &&
        `${parseISO(date).toLocaleDateString("pt-BR")} às ${parseISO(
          date,
        ).toLocaleTimeString("pt-BR")}`,
    },
    {
      title: t("user"),
      dataIndex: "user",
      render: (creator: IUser) => {
        if (creator) {
          return (
            <UserAvatar
              name={creator.name}
              url={creator.avatar_url}
              size={36}
            />
          );
        }
        return <></>;
      },
    },
    {
      title: t("old_status"),
      dataIndex: "old_status",
      render: (old_status: string) => {
        return (
          <Tag
            color={t(`status.options.${old_status}.color`, {
              ns: "projects",
            })}
          >
            {t(`status.options.${old_status}.label`, {
              ns: "projects",
            })}
          </Tag>
        );
      },
    },
    {
      title: t("new_status"),
      dataIndex: "new_status",
      render: (new_status: string) => {
        return (
          <Tag
            color={t(`status.options.${new_status}.color`, {
              ns: "projects",
            })}
          >
            {t(`status.options.${new_status}.label`, {
              ns: "projects",
            })}
          </Tag>
        );
      },
    },
    {
      title: t("reason"),
      dataIndex: "reason",
    },
  ];

  const extraFilters = useMemo(() => (showFilters ? <FiltersCard /> : <></>), [
    showFilters,
  ]);

  const isValidStatus = useMemo(
    () =>
      project?.status === ProjectStatus.WaitingApproval ||
      project?.status === ProjectStatus.Approved ||
      project?.status === ProjectStatus.WaitingDevelopment ||
      project?.status === ProjectStatus.Development ||
      project?.status === ProjectStatus.ProposalSending ||
      project?.status === ProjectStatus.Assigning,
    [project?.status],
  );

  const requirementsExtraActions: JSX.Element = useMemo(() => {
    if (
      isLoggedUserManager &&
      project?.status === ProjectStatus.Understanding
    ) {
      return (
        <Tooltip title={t("actions.options.create")}>
          <Button
            icon={<PlusCircleOutlined />}
            type="link"
            size="large"
            onClick={() => setModalVisible(true)}
          />
        </Tooltip>
      );
    }

    if (
      ((isLoggedUserManager || userExistProject) && isValidStatus) ||
      project?.public_project
    ) {
      return (
        <Tooltip title={t("actions.options.create")}>
          <Button
            icon={<PlusCircleOutlined />}
            type="link"
            size="large"
            onClick={() => setModalAddActivityVisible(true)}
          />
        </Tooltip>
      );
    }
    return <></>;
  }, [isLoggedUserManager, isValidStatus, t, project, userExistProject]);

  const showCustomerDetails = useMemo(
    () =>
      !!project?.projectType.acronym &&
      project?.projectType.acronym !== ProjectTypes.Internal,
    [project?.projectType.acronym],
  );

  const showBaseProject = useMemo(
    () =>
      !!project?.projectType.acronym &&
      (project?.projectType.acronym === ProjectTypes.Corrective ||
        project?.projectType.acronym === ProjectTypes.Incident),
    [project?.projectType.acronym],
  );

  const handleCloseNewActivityModal = useCallback((activity?: IRequirement) => {
    if (activity) {
      setActivities(oldActivities => [activity, ...oldActivities]);
    }
    setModalVisible(false);
  }, []);

  const handleCloseDeleteActivityModal = useCallback(
    (activity_id?: string) => {
      setModalDeleteVisible(false);
      if (activity_id) {
        setLoading(old => !old);
        setActivities(oldActivities => {
          return oldActivities.filter(act => act.id !== activity_id);
        });
        setLoading(old => !old);
      }
    },
    [setModalDeleteVisible, setActivities],
  );

  const handleCloseActivityEditModal = useCallback(
    (activity?: IRequirement) => {
      setSelectedActivity(undefined);
      if (activity) {
        const index = activities.findIndex(act => act.id === activity.id);
        setActivities(oldActivities => {
          if (index > -1) {
            // eslint-disable-next-line no-param-reassign
            oldActivities[index] = activity;
          }
          return [...oldActivities];
        });
      }
      setModalEditVisible(false);
    },
    [activities],
  );

  const handleCloseActivityActionModal = useCallback(
    (activity?: IRequirement) => {
      setSelectedActivity(undefined);
      if (activity) {
        const index = activities.findIndex(act => act.id === activity.id);
        const newActivities = activities;

        if (index > -1) {
          newActivities[index] = activity;
        } else {
          newActivities.push(activity);
        }
        setActivities([...newActivities]);
      }
      setAssignActivityModalVisible(false);
      setVisibleActivityFactory(false);
    },
    [activities],
  );

  const handleCloseModalAddActivity = useCallback((acts?: IRequirement[]) => {
    setModalAddActivityVisible(false);
    if (acts) {
      setProject(old => {
        if (!old) {
          return old;
        }
        return { ...old, requirements: acts };
      });
    }
  }, []);

  const handleCloseActivityActionsHistoryModal = useCallback(() => {
    setActivityActionsModalVisible(false);
  }, []);

  useEffect(() => {
    setProject(oldProject => {
      if (oldProject) {
        const newProject = oldProject;
        newProject.requirements = activities;
        return newProject;
      }
      return oldProject;
    });
  }, [activities]);

  const CardActivityEstimate = () => {
    const allActivities = project?.requirements?.length || 0;
    const activityEstimate =
      project?.requirements?.filter(activity => activity.hours).length || 0;

    return `${activityEstimate} / ${allActivities}`;
  };

  const validatePurchaseOrder = useMemo(() => {
    const disabledStatus = [
      ProjectStatus.Estimate,
      ProjectStatus.Understanding,
      ProjectStatus.ProposalSending,
      ProjectStatus.WaitingApproval,
    ];
    return (
      project?.purchase_order ||
      !disabledStatus.includes(project?.status as ProjectStatus)
    );
  }, [project]);

  const handleCloseModalRemoveImpediment = useCallback(
    (activity_id?: string) => {
      if (activity_id) {
        setProject(oldProject => {
          if (!oldProject) {
            return oldProject;
          }
          // eslint-disable-next-line no-param-reassign
          oldProject.requirements = oldProject.requirements.map(activity => {
            if (activity.id === activity_id) {
              // eslint-disable-next-line no-param-reassign
              activity.comments = activity.comments?.map(comment => {
                if (comment?.status === IStatusImpediment.warning) {
                  // eslint-disable-next-line no-param-reassign
                  comment.status = IStatusImpediment.concluded;
                }
                return comment;
              });
            }
            return activity;
          });
          return oldProject;
        });
      }
      setModalRemoveImpedimentVisible(false);
    },
    [],
  );

  const CardHistoricDev = (): string => {
    const allActivities = project?.requirements?.length || 0;
    const activityEstimate =
      project?.requirements
        .map(
          activity =>
            activity.comments?.filter(c => c?.comment_activity).length,
        )
        .filter(el => el && el > 0).length || 0;

    return `${activityEstimate} / ${allActivities}`;
  };

  return project ? (
    <Container>
      <Header>
        <Button
          onClick={() => history.goBack()}
          type="link"
          icon={<ArrowLeftOutlined />}
          size="large"
        >
          Voltar
        </Button>
        {isLoggedUserManager && (
          <ProjectActions
            project={project}
            proposal={proposal}
            handleUpdateProject={proj => setProject(proj)}
          />
        )}
      </Header>

      <ActivityEditModal
        visible={modalEditVisible}
        activity={selectedActivity}
        handleClose={handleCloseActivityEditModal}
      />

      <AddActivityAllTime
        visible={modalAddActivityVisible}
        project={project}
        handleCloseModal={handleCloseModalAddActivity}
      />

      <RemoveImpediment
        visible={modalRemoveImpedimentVisible}
        handleClose={handleCloseModalRemoveImpediment}
        activity={selectedActivity}
      />

      <DeleteActivityModal
        activity={selectedActivity}
        visible={modalDeleteVisible}
        handleCloseModal={handleCloseDeleteActivityModal}
      />

      <ActivityModal
        visible={modalVisible}
        projectId={projectId}
        projectType={project.projectType.acronym}
        pricing={project?.pricing}
        handleCloseModal={handleCloseNewActivityModal}
      />
      <AssignActivityModal
        activity={selectedActivity}
        visible={assignActivityModalVisible}
        handleClose={handleCloseActivityActionModal}
      />
      <ActivityActionsHistoryModal
        activity={selectedActivity}
        visible={activityActionsModalVisible}
        handleClose={handleCloseActivityActionsHistoryModal}
      />
      <HistoricActivityModal
        activity={selectedActivity}
        visible={visibleActivityFactory}
        handleClose={handleCloseActivityActionModal}
        editHistoricActivity
        show_comments={comments}
      />
      <Space direction="vertical" size="middle" style={{ display: "flex" }}>
        <Row gutter={[12, 12]}>
          <Col xs={24} lg={8}>
            <Space direction="vertical">
              <Stat
                title={t("project-types.label", { ns: "projects" })}
                loading={loading}
                value={
                  t(
                    `project-types.options.${project.projectType.acronym}.label`,
                    {
                      ns: "projects",
                    },
                  ) || ""
                }
                icon={<BranchesOutlined />}
              />
              <Stat
                title={t("status.label")}
                value={
                  t(`status.options.${project.status}.label`, {
                    ns: "projects",
                  }) || ""
                }
                noStyleIcon
                loading={loading}
                icon={
                  <Badge
                    text={<></>}
                    color={t(`status.options.${project.status}.color`, {
                      ns: "projects",
                    })}
                  />
                }
              />
              {project.manager && (
                <Stat
                  title={t("proposal_number_ethic", { ns: "projects" })}
                  value={project?.proposal_number_ethic || "Não Definido"}
                  loading={loading}
                  noFormat
                  icon={<FilePptOutlined />}
                />
              )}
              <Stat
                title={t("expected_start", { ns: "projects" })}
                value={
                  project.expected_start
                    ? parseISO(project.expected_start).toLocaleDateString(
                        "pt-BR",
                      )
                    : t("not_defined_masculine", { ns: "projects" })
                }
                icon={<CalendarOutlined />}
                loading={loading}
                editComponent={
                  <EditFieldModal
                    fieldName="expected_start"
                    project={project}
                    handleUpdateProject={proj => setProject(proj)}
                    inputType="DATE"
                  />
                }
                valueHistoryComponent={
                  <FieldValueHistoryModal
                    project={project}
                    fieldName="expected_start"
                    valueRenderFunction={
                      value => parseISO(value).toLocaleDateString("pt-BR")
                      // ts-ignore
                    }
                  />
                }
              />
              {!showCustomerDetails && (
                <Stat
                  title={t("expected_end", { ns: "projects" })}
                  value={
                    project.expected_end
                      ? parseISO(project.expected_end).toLocaleDateString(
                          "pt-BR",
                        )
                      : t("not_defined_feminine", { ns: "projects" })
                  }
                  icon={<CalendarOutlined />}
                  loading={loading}
                  editComponent={
                    <EditFieldModal
                      fieldName="expected_end"
                      project={project}
                      handleUpdateProject={proj => setProject(proj)}
                      inputType="DATE"
                    />
                  }
                  valueHistoryComponent={
                    <FieldValueHistoryModal
                      project={project}
                      fieldName="expected_end"
                      valueRenderFunction={
                        value => parseISO(value).toLocaleDateString("pt-BR")
                        // ts-ignore
                      }
                    />
                  }
                />
              )}
            </Space>
          </Col>
          {showCustomerDetails ? (
            <>
              <Col xs={24} lg={8}>
                <Space direction="vertical">
                  <Stat
                    title={t("customer", { ns: "projects" })}
                    value={project.customer?.name || ""}
                    icon={<IdcardOutlined />}
                    loading={loading}
                  />
                  <Stat
                    title={t("purchase_order", { ns: "projects" })}
                    value={`${project.purchase_order}` || "Não informada"}
                    noFormat
                    icon={<BarcodeOutlined />}
                    loading={loading}
                    editComponent={
                      validatePurchaseOrder ? (
                        <EditFieldModal
                          fieldName="purchase_order"
                          project={project}
                          handleUpdateProject={proj => setProject(proj)}
                        />
                      ) : (
                        <></>
                      )
                    }
                  />
                  <Stat
                    title={
                      showBaseProject
                        ? t("base_identifier", { ns: "projects" })
                        : t("identifier", { ns: "projects" })
                    }
                    value={
                      (showBaseProject
                        ? project.baseProject.identifier
                        : project?.identifier ||
                          t("no_identifier", { ns: "projects" })) || ""
                    }
                    icon={
                      showBaseProject ? (
                        <Link to={`/app/projects/${project.baseProject.id}`}>
                          <FileSearchOutlined />
                        </Link>
                      ) : (
                        <FileSearchOutlined />
                      )
                    }
                    loading={loading}
                    editComponent={
                      showBaseProject ? (
                        <></>
                      ) : (
                        <EditFieldModal
                          fieldName="identifier"
                          project={project}
                          handleUpdateProject={proj => setProject(proj)}
                        />
                      )
                    }
                    valueHistoryComponent={
                      showBaseProject ? (
                        <></>
                      ) : (
                        <FieldValueHistoryModal
                          project={project}
                          fieldName="identifier"
                        />
                      )
                    }
                  />
                  <Stat
                    title={t("expected_end", { ns: "projects" })}
                    value={
                      project.expected_end
                        ? parseISO(project.expected_end).toLocaleDateString(
                            "pt-BR",
                          )
                        : t("not_defined_feminine", { ns: "projects" })
                    }
                    icon={<CalendarOutlined />}
                    loading={loading}
                    editComponent={
                      <EditFieldModal
                        fieldName="expected_end"
                        project={project}
                        handleUpdateProject={proj => setProject(proj)}
                        inputType="DATE"
                      />
                    }
                    valueHistoryComponent={
                      <FieldValueHistoryModal
                        project={project}
                        fieldName="expected_end"
                        valueRenderFunction={
                          value => parseISO(value).toLocaleDateString("pt-BR")
                          // ts-ignore
                        }
                      />
                    }
                  />
                </Space>
              </Col>
              <Col xs={24} lg={8}>
                <Space direction="vertical">
                  <Stat
                    title={t("contractor_name", { ns: "projects" })}
                    value={project.contractor_name || ""}
                    icon={<UserOutlined />}
                    loading={loading}
                    editComponent={
                      <EditFieldModal
                        fieldName="contractor_name"
                        project={project}
                        handleUpdateProject={proj => setProject(proj)}
                      />
                    }
                    valueHistoryComponent={
                      <FieldValueHistoryModal
                        project={project}
                        fieldName="contractor_name"
                      />
                    }
                  />
                  <Stat
                    title={t("contractor_email", { ns: "projects" })}
                    value={project.contractor_email || ""}
                    icon={
                      // eslint-disable-next-line jsx-a11y/anchor-is-valid
                      <Button
                        type="link"
                        href={`mailto:${project.contractor_email}`}
                      >
                        <MailOutlined />
                      </Button>
                    }
                    loading={loading}
                    editComponent={
                      <EditFieldModal
                        fieldName="contractor_email"
                        project={project}
                        handleUpdateProject={proj => setProject(proj)}
                        validationRule={Yup.string().email("E-mail inválido")}
                      />
                    }
                    valueHistoryComponent={
                      <FieldValueHistoryModal
                        project={project}
                        fieldName="contractor_email"
                      />
                    }
                  />
                  <Stat
                    title={t("contractor_phone_number", { ns: "projects" })}
                    value={
                      project.contractor_phone_number
                        ? `${project.contractor_phone_number?.toString()} `
                        : "Não informado"
                    }
                    icon={
                      <Button
                        type="link"
                        href={`tel:${project.contractor_phone_number}`}
                      >
                        <PhoneOutlined />
                      </Button>
                    }
                    loading={loading}
                    editComponent={
                      <EditFieldModal
                        fieldName="contractor_phone_number"
                        project={project}
                        handleUpdateProject={proj => setProject(proj)}
                      />
                    }
                    valueHistoryComponent={
                      <FieldValueHistoryModal
                        project={project}
                        fieldName="contractor_phone_number"
                      />
                    }
                  />
                  {project.manager && (
                    <Stat
                      title={t("manager", { ns: "projects" })}
                      value={project.manager.name}
                      noStyleIcon
                      loading={loading}
                      icon={
                        <UserAvatar
                          name={project.manager.name}
                          url={project.manager.avatar_url}
                          size={36}
                        />
                      }
                      editComponent={
                        <EditFieldModal
                          fieldName="manager_id"
                          project={project}
                          handleUpdateProject={proj => setProject(proj)}
                          inputType="SELECT"
                          selectOptions={managerOptions}
                        />
                      }
                      valueHistoryComponent={
                        <FieldValueHistoryModal
                          project={project}
                          fieldName="manager_id"
                          valueRenderFunction={manager_id =>
                            managerOptions?.find(
                              manager => manager.value === manager_id,
                              // eslint-disable-next-line prettier/prettier
                              )?.label || manager_id}
                        />
                      }
                    />
                  )}
                </Space>
              </Col>
            </>
          ) : (
            <Col xs={24} lg={16}>
              <CardContainer>
                <Card
                  style={{ height: "100%" }}
                  loading={loading}
                  title={
                    project.identifier
                      ? `${project.identifier} - ${project.short_description}`
                      : project.short_description
                  }
                  extra={
                    <ActionsContainer>
                      <EditFieldModal
                        fieldName="short_description"
                        project={project}
                        handleUpdateProject={proj => setProject(proj)}
                      />
                      <FieldValueHistoryModal
                        project={project}
                        fieldName="short_description"
                      />
                    </ActionsContainer>
                  }
                >
                  <FloatActionsContainer>
                    <EditFieldModal
                      fieldName="full_description"
                      project={project}
                      handleUpdateProject={proj => setProject(proj)}
                      inputType="TEXTAREA"
                    />
                    <FieldValueHistoryModal
                      project={project}
                      fieldName="full_description"
                    />
                  </FloatActionsContainer>
                  <Paragraph
                    ellipsis={{
                      rows: 10,
                      expandable: true,
                      symbol: "ler mais",
                    }}
                  >
                    {project.full_description}
                  </Paragraph>
                </Card>
              </CardContainer>
            </Col>
          )}
        </Row>

        {showCustomerDetails && (
          <CardContainer>
            <Card
              loading={loading}
              title={
                showBaseProject
                  ? `${project.identifier} - ${project.short_description}`
                  : project.short_description
              }
              extra={
                <ActionsContainer>
                  <EditFieldModal
                    fieldName="short_description"
                    project={project}
                    handleUpdateProject={proj => setProject(proj)}
                  />
                  <FieldValueHistoryModal
                    project={project}
                    fieldName="short_description"
                  />
                </ActionsContainer>
              }
            >
              <FloatActionsContainer>
                <EditFieldModal
                  fieldName="full_description"
                  project={project}
                  handleUpdateProject={proj => setProject(proj)}
                  inputType="TEXTAREA"
                />
                <FieldValueHistoryModal
                  project={project}
                  fieldName="full_description"
                />
              </FloatActionsContainer>
              <Paragraph
                ellipsis={{ rows: 10, expandable: true, symbol: "ler mais" }}
              >
                {project.full_description}
              </Paragraph>
            </Card>
          </CardContainer>
        )}
        {project?.projectType.acronym === ProjectTypes.Factory && (
          <Space direction="vertical" size="middle" style={{ display: "flex" }}>
            <Row gutter={[12, 12]}>
              <Col xs={24} lg={8}>
                <Space direction="vertical">
                  <Stat
                    title="Atividade Estimadas"
                    loading={loading}
                    value={CardActivityEstimate()}
                    icon={<ForkOutlined />}
                  />
                </Space>
              </Col>
              <Col xs={24} lg={8}>
                <Space direction="vertical">
                  <Space direction="vertical">
                    <Stat
                      title="Historico das Atividades"
                      loading={loading}
                      value={CardHistoricDev()}
                      icon={<DeploymentUnitOutlined />}
                    />
                  </Space>
                </Space>
              </Col>
            </Row>
          </Space>
        )}
        <Table
          data={project.requirements || []}
          columns={requirementsColumns}
          title={
            <>
              Atividades
              {/* <Filters
              showFilters={showFilters}
              setShowFilters={handleShowFilters}
            /> */}
            </>
          }
          extraActions={requirementsExtraActions}
          footer={() => <></>}
          loading={loading}
          pagination={false}
          extraFilters={extraFilters}
        />
        {/* <EstimatorActivities project={project} updateProject={updateProject} /> */}
        <Table
          data={project.actionsHistory || []}
          columns={actionsHistoryColumns}
          title={
            <>
              Histórico
              {/* <Filters
              showFilters={showFilters}
              setShowFilters={handleShowFilters}
            /> */}
            </>
          }
          footer={() => <></>}
          loading={loading}
          pagination={false}
        />
      </Space>
    </Container>
  ) : (
    <></>
  );
};

export default Project;
